// extracted by mini-css-extract-plugin
export var searchHeader = "_6i-0";
export var searchHeaderDark = "_6i-1";